<template>
  <div class="container">
    <div class="main-container">
      <div class="left-box">
        <div class="panel address-panel">
          <h2 class="title">
            <span>确认收货地址</span>
            <span class="btn-address" @click="add_address">使用新地址</span>
          </h2>
          <div class="address-list">
            <div
              class="address-item"
              :class="{ active: form_data.address_id === v.id }"
              v-for="(v, k) in address_list"
              :key="`a` + k"
              @click="change_address(v)"
            >
              <img
                v-if="form_data.address_id === v.id"
                src="../../assets/images/icon-location-active.png"
                class="location"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/icon-location.png"
                class="location"
                alt=""
              />
              <div class="content1">
                <span>{{ v.province }}</span
                ><span>{{ v.city }}</span
                ><span>{{ v.zone }}</span>
              </div>
              <div class="content2">
                {{ v.address }}
              </div>
              <div class="contact">
                {{ v.contact_person }}{{ v.contact_mobile }}
              </div>
              <div class="btn-edit" @click.stop="edit_address(v.id)">编辑</div>
            </div>
          </div>
        </div>

        <popup
          :show.sync="is_popup_show"
          width="490px"
          height="520px"
          @on-close="close"
        >
          <h2>{{ form_data_address.id ? "编辑收货地址" : "添加收货地址" }}</h2>
          <div class="form">
            <div class="form-group">
              <div class="form-label">收货人：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入收货人"
                  v-model="form_data_address.contact_person"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">手机号：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入手机号"
                  v-model="form_data_address.contact_mobile"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">所在地区：</div>
              <div class="form-control">
                <Cascader
                  class="input1"
                  :data="region"
                  v-model="value"
                  placeholder="请选择省/市/区/街道"
                ></Cascader>
              </div>
            </div>

            <div class="form-group">
              <div class="form-label">详细地址：</div>
              <div class="form-control">
                <input
                  type="text"
                  class="input"
                  placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"
                  v-model="form_data_address.address"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label"></div>
              <div class="form-control">
                <input
                  type="checkbox"
                  v-model="form_data_address.is_default"
                />是否默认地址
              </div>
            </div>
            <div class="btn-submit" @click="save">保存地址</div>
          </div>
        </popup>

        <div class="panel product-panel">
          <table border>
            <thead>
              <tr>
                <th>产品信息</th>
                <th>尺码</th>
                <th>数量</th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="(v, k) in detail.mtms" :key="k">
                  <td>
                    <div class="info">
                      <img
                        :src="v.design_data.category.image"
                        alt=""
                        class="image"
                      />
                      <div class="name">
                        {{ v.design_data.category.style_no }}
                      </div>
                      <div class="category">
                        {{ v.design_data.category.product_category_name }}
                      </div>
                    </div>
                  </td>
                  <td>
                    {{ v.spec_info.join("；") }}
                  </td>
                  <td>×{{ v.quantity }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="panel summary-panel">
          <div class="wrap">
            <div class="left">
              <div class="item">
                <div class="label" style="font-size: 15px">订单详情</div>
                <div class="text"></div>
              </div>
              <div class="item">
                <div class="label">订单号：</div>
                <div class="text">{{ detail.order_no }}</div>
              </div>
              <div class="item">
                <div class="label">下单日期：</div>
                <div class="text">{{ detail.create_time }}</div>
              </div>
              <div class="item">
                <div class="label">要求发货日期：</div>
                <div class="text">
                  <input type="date" v-model="form_data.date_required" />
                </div>
              </div>
            </div>
            <div class="right">
              <h2 class="title">订单备注</h2>
              <textarea
                cols="30"
                rows="10"
                v-model="form_data.comment"
                placeholder="请输入备注"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="panel operation-panel">
          <h2 class="title">{{ is_bulk_order ? "大货报价单" : "样衣定制报价单" }}</h2>
          <div class="item" v-for="(vv, kk) in detail.cost_list" :key="kk">
            <div class="label">{{ vv.title }}</div>
            <div class="text">￥{{ vv.amount }}</div>
          </div>

          <div class="separator"></div>
          <div class="item" v-if="!is_bulk_order">
            <div class="label">实付款</div>
            <div class="text" style="font-size: 18px; color: #fa3d5a">
              ￥{{ total_price }}
            </div>
          </div>

          <div class="integral" v-if="!is_bulk_order && setting.c_coupon_deduct_coupon >0 && setting.max_c_coupon_deduct_ratio">
            <label class="checkbox-label">
              <input type="checkbox" :checked="useCCouponDeduct" @change="switchCCouponChange"/>消费券抵扣<span>(当前账号消费券{{userInfo.c_coupon || 0}})</span>
            </label>
            <div class="checkbox-value">¥{{ c_coupon_pay_money }}</div>
          </div>

          <div class="integral" v-if="!is_bulk_order && pointSetting.shoppingDeductPoint >0 && pointSetting.maxDeductRatio > 0">
              <label class="checkbox-label">
                <input type="checkbox" :checked="usePointDeduct" @change="switchPointChange"/>积分抵扣<span>(当前账号积分{{userInfo.point || 0}})</span>
              </label>
              <div class="checkbox-value">¥{{ point_pay_money }}</div>
          </div>

          <div class="pay-list" v-if="!is_bulk_order">
            <label class="pay-item" v-for="(v, k) in pay_list" :key="`pa` + k">
              <input
                type="checkbox"
                :checked="v.checked"
                @change="change_payment(v)"
              />
              <img :src="v.icon" alt="" class="icon" />
              <div>
                {{ v.name
                }}<span v-if="v.type === 'balance'"
                  >(余额:¥{{ userInfo.available_balance }})</span
                >
              </div>
            </label>
          </div>
          <div class="expedited" v-if="!is_bulk_order">
            <input
              type="checkbox"
              :checked="is_expedited"
              @click.stop="onSetExpedited"
            />
            是否加急
          </div>
          <div class="expedited" v-if="!is_bulk_order">
            <input
              type="checkbox"
              :checked="form_data.is_tech_real"
              @click.stop="toggle2"
            />
            是否印绣花打样确认
          </div>
          <div class="expedited" v-if="!is_bulk_order">
            <input
              type="checkbox"
              :checked="form_data.is_try_pattern"
              @click.stop="onChangeTryPattern"
            />
            是否代料试版
          </div>
          <div class="btn-checkout" @click="checkout">{{ is_bulk_order ? "提交订单，获取报价" : "确认支付" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AddressList,
  ChangeExpedited,
  ChangeTryPattern,
  CheckoutOrder,
  GetAddress,
  getSetting,
  OrderDetail,
  PayOrder,
  Profile,
  SaveAddress,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import region from "@/utils/region.js";
import axios from "axios";
import { mapState } from "vuex";

const form_data_address = {
  id: 0,
  contact_person: "",
  contact_mobile: "",
  province: "",
  city: "",
  zone: "",
  address: "",
  is_default: 0,
};
export default {
  name: "OrderCheckout",
  components: {
    Popup,
  },
  data() {
    return {
      value: [],
      region: region,
      form_data_address: { ...form_data_address },
      is_popup_show: false,
      is_click: false,
      address_list: [],
      form_data: {
        address_id: 0,
        uuid: "",
        date_required: "",
        comment: "",
        is_tech_real: false,
        is_try_pattern: false,
      },
      pay_type: "wechat",
      detail: {
        spec_info: [],
        cost_list: [],
        cost: [],
      },
      design: {},
      pay_list: [
        {
          name: "微信支付",
          icon: require("../../assets/images/icon_weixin@2x.png"),
          type: "wechat",
          checked: true,
        },
        {
          name: '支付宝支付',
          icon: require('../../assets/images/icon_zhifubao@2x.png'),
          type: 'alipay',
          checked: false,
        },
        {
          name: `余额支付`,
          icon: require("../../assets/images/icon-balance-pay.png"),
          type: "balance",
          checked: false,
        },
      ],
      is_expedited:false,
      useCCouponDeduct:false,
      usePointDeduct:false,
      pointSetting:{
        shoppingDeductPoint: 0,
        maxDeductPoint: 0,
      },
    };
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
      userInfo: (state) => state.userInfo
    }),
    c_coupon_pay_money() {
      let c_coupon_pay_money = 0
      if (this.useCCouponDeduct) {
        let maxDeductPrice = this.setting.max_c_coupon_deduct_ratio / 100 * (this.detail.total_price);
        if ((this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon) >= maxDeductPrice) {
          c_coupon_pay_money = maxDeductPrice;
        } else {
          c_coupon_pay_money = Number(this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon);
        }
        return c_coupon_pay_money.toFixed(2)
      }
      return c_coupon_pay_money
    },
    point_pay_money() {
      if (this.usePointDeduct) {
        var maxDeductPrice = this.pointSetting.maxDeductRatio / 100 * (this.detail.total_price - this.c_coupon_pay_money);
        if ((this.userInfo.point * this.pointSetting.shoppingDeductPoint) > maxDeductPrice) {
          var point_pay_money = maxDeductPrice;
        } else {
          var point_pay_money = this.userInfo.point * this.pointSetting.shoppingDeductPoint;
        }
        return point_pay_money.toFixed(2)
      }
      return 0
    },
    virtual_pay_money() {
      return Number(this.point_pay_money) + Number(this.c_coupon_pay_money)
    },
    total_price() {
      return Number(this.detail.total_price - this.c_coupon_pay_money - this.point_pay_money).toFixed(2);
    },
    is_bulk_order() {
      return this.detail.quantity > 10 && this.detail.status == -1;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      console.log("aaa");
      vm.$emit("showFooter", false);
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
  async mounted() {
    await this.$store.dispatch("getSetting");
    if (this.setting.offlinePay) {
      this.pay_list.push({
        name: "线下支付",
        icon: require("../../assets/images/icon-pay-offline.png"),
        type: "offline",
        checked: false,
      });
    }
    this.getPointSetting();
    const {uuid} = this.$route.query;
    this.form_data.uuid = uuid;
    if (!uuid) {
      this.$router.back();
      return;
    }

    let data = await this.onGetDetail();
    this.form_data.is_tech_real = Boolean(data.is_tech_real);
    axios.all([this.getProfile(), this.getAddressList()]).then(
      axios.spread(() => {
        console.log('data--->',data);
        let default_address = this.address_list.find((elem, key) => {
          return elem.is_default === 1;
        });

        const {province, city, zone, address, contact_mobile, contact_person} = data;
        let current;
        if(province && city && zone && address && contact_mobile && contact_person){
          current = this.address_list.find((item)=>{
            return item.province === province && item.city === city && item.zone === zone && item.address === address && item.contact_mobile === contact_mobile && item.contact_person === contact_person;
          })
        }
        this.form_data.address_id = default_address ? default_address.id : 0;
        if(current){
          this.form_data.address_id = current.id;
        }
      })
    );
  },
  methods: {
    async getPointSetting() {
      let { data } = await getSetting({ code: "user", key: "pointSetting" });
      if (data) {
        this.pointSetting = data;
      }
    },
    switchPointChange(e) {
      this.usePointDeduct = !this.usePointDeduct
    },
    switchCCouponChange(e) {
      this.useCCouponDeduct = !this.useCCouponDeduct
    },
    onSetExpedited(){
      this.is_expedited = !this.is_expedited;
      this.onChangeExpedited();
    },
    toggle2() {
      this.form_data.is_tech_real = !this.form_data.is_tech_real;
    },
    toggle3() {
      this.form_data.is_try_pattern = !this.form_data.is_try_pattern;
    },
    onGetDetail() {
      return OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
        this.design = this.detail.design;
        this.form_data.is_try_pattern = this.detail.is_try_pattern;
        this.is_expedited = this.detail.urgent;
        return response.data;
      });
    },
    async onChangeExpedited() {
      try {
        const param = {};
        param.is_expedited = this.is_expedited;
        param.uuid = this.detail.uuid;
        console.log("expedited_param", param);
        await ChangeExpedited(param);
      } catch (e) {
        console.log("err-expedited", e);
      } finally {
        await this.onGetDetail();
      }
    },
    async onChangeTryPattern() {
      try {
        this.toggle3();
        const param = {};
        param.is_try_pattern = this.form_data.is_try_pattern;
        param.uuid = this.detail.uuid;
        await ChangeTryPattern(param);
      } catch (e) {
        console.log(e);
      } finally {
        await this.onGetDetail();
      }
    },
    close() {
      this.form_data_address = { ...form_data_address };
      this.value = [];
    },
    save() {
      this.form_data_address.province = this.value[0];
      this.form_data_address.city = this.value[1];
      this.form_data_address.zone = this.value[2];
      if(!this.form_data_address.contact_person){
        this.$layer.msg('请输入姓名');
        return;
      }
      if(!this.form_data_address.contact_mobile){
        this.$layer.msg('请输入手机号');
        return;
      }
      if(!this.form_data_address.province){
        this.$layer.msg('请选择省份');
        return;
      }
      if(!this.form_data_address.city){
        this.$layer.msg('请选择城市');
        return;
      }
      if(!this.form_data_address.zone){
        this.$layer.msg('请选择区县');
        return;
      }
      if(!this.form_data_address.address){
        this.$layer.msg('请输入详细地址');
        return;
      }
      SaveAddress(this.form_data_address)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.form_data_address = { ...form_data_address };
          this.value = [];
          this.is_popup_show = false;
          this.getAddressList();
        })
    },
    add_address() {
      this.is_popup_show = true;
    },
    edit_address(id) {
      GetAddress({ id }).then((response) => {
        this.form_data_address = response.data;
        this.value = [
          this.form_data_address.province,
          this.form_data_address.city,
          this.form_data_address.zone,
        ];
        this.is_popup_show = true;
      });
    },
    change_payment(e) {
      console.log(e);
      if (e.type == "offline") {
        this.$set(e, "checked", !e.checked);
        this.pay_list.forEach((i) => {
          if (i.type == "offline") {
            i.checked = e.checked;
          } else {
            i.checked = false;
          }
        });
      } else if (e.type == "wechat" || e.type == "alipay") {
        this.$set(e, "checked", !e.checked);
        this.pay_list.forEach((i) => {
          if (i.type == "offline" && i.checked) {
            i.checked = false;
          }
          if ((i.type == "wechat" || i.type == "alipay") && i.type != e.type) {
            i.checked = false;
          }
        });
      } else {
        this.$set(e, "checked", !e.checked);
        this.pay_list.forEach((i) => {
          if (i.type == "offline" && i.checked) {
            i.checked = false;
          }
        });
      }
    },
    async checkout() {
      if (this.is_click) {
        return;
      }
      if (this.form_data.address_id === 0) {
        this.$layer.msg(`请选择收货地址`);
        return;
      }

      // 大货订单直接提交，不进入支付流程
      if (this.is_bulk_order) {
        this.is_click = true;
        CheckoutOrder({ ...this.form_data })
          .then(() => {
            this.$layer.msg(`提交成功，等待平台报价`);
            setTimeout(() => {
              this.$router.replace({
                name: "OrderDetail",
                query: { uuid: this.form_data.uuid },
              });
            }, 1500);
          })
          .catch((e) => {
            this.$layer.msg(e.msg);
          })
          .finally(() => {
            this.is_click = false;
          });
        return;
      }

      // 接口参数预处理 Start
      let payTypes = this.pay_list.filter((i) => {
        return i.checked
      }).map((i) => {
        return i.type
      })
      if (payTypes.length == 0) {
        return this.$layer.msg('请选择支付方式')
      }
      let pay_param = {
        use_balance: false,
        use_wechat: false,
        use_alipay: false,
        use_offline:false,
        usePointDeduct:this.usePointDeduct,
        useCCouponDeduct:this.useCCouponDeduct,
      }
      if (payTypes.indexOf('balance') >= 0) {
        pay_param.use_balance = true
      }
      if (payTypes.indexOf('wechat') >= 0) {
        pay_param.use_wechat = true
      }
      if (payTypes.indexOf('alipay') >= 0) {
        pay_param.use_alipay = true
      }
      if (payTypes.indexOf('offline') >= 0) {
        pay_param.use_offline = true
      }
      // 积分、消费券等都属于虚拟财产支付
      let is_virtual_pay = this.usePointDeduct || this.useCCouponDeduct
      // 后续增加支付宝等，都属于三方在线支付
      let is_online_pay = pay_param.use_wechat || pay_param.use_alipay
      // 接口参数预处理 End

      this.is_click = true;
      CheckoutOrder({...this.form_data, pay_param})
        .then(({data}) => {
          console.log('res-data',data);
          // 虚拟财产支付足够订单金额
          if(this.virtual_pay_money >= this.detail.total_price) {
            this.payBalance()
            return;
          }
          //使用余额且余额足够支付订单剩余金额
          if(pay_param.use_balance && Number(this.userInfo.available_balance) >= Number(this.detail.total_price - this.virtual_pay_money)) {
            this.payBalance()
            return;
          }
          //>只有余额支付操作
          if(pay_param.use_balance && !is_online_pay) {
            this.payBalance()
            return;
          }

          //
          var pay_type = ''
          if (pay_param.use_wechat) {
            pay_type = 'wechat'
          }
          if (pay_param.use_alipay) {
            pay_type = 'alipay'
          }
          if (pay_param.use_offline) {
            pay_type = 'offline'
          }
          this.$layer.msg(`订单已确认，跳转支付中...`);
          setTimeout(() => {
            this.$router.replace({
              name: "CashDesk",
              query: { uuid: this.form_data.uuid, pay_type },
            });
          }, 1500);
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.is_click = false;
        });
    },

    payBalance() {
      const param = {};
      param.uuid = this.form_data.uuid;
      param.pay_type = 'balance';
      param.usePointDeduct = this.usePointDeduct
      param.useCCouponDeduct = this.useCCouponDeduct
      this.$Spin.show();
      PayOrder(param)
        .then((res) => {
          console.log("res-pay", res);
          this.$layer.msg("支付成功");
          this.$router.replace({
            name: "PayResult",
            query: { uuid: param.uuid },
          });
        })
        .catch((e) => {
          console.log("err-pay", e);
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },
    go2address() {
      this.$router.push({ name: "Address" });
    },
    change_address(v) {
      this.form_data.address_id = v.id;
    },
    async getProfile() {
      return Profile().then((response) => {
        this.$store.commit("setUserInfo", this.$_.cloneDeep(response.data));
        return response;
      });
    },
    async getAddressList() {
      return AddressList().then((response) => {
        this.address_list = response.data;
        return response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1279px;
  max-width: 1920px;
  background: #f6f7fa;
  .main-container {
    width: 100%;
    max-width: 1516px;
    display: flex;
    justify-content: center;
    column-gap: 16px;
    .left-box {
      //   width: 100%;
      //   max-width: 1140px;
      flex: 3;
      min-width: 700px;
      display: flex;
      flex-direction: column;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.address-panel {
          max-width: 1140px;
          .title {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            .btn-address {
              color: #fa3d5a;
              font-size: 12px;
              font-weight: normal;
              cursor: pointer;
              margin: 0 10px;
            }
          }
          .address-list {
            display: flex;
            flex-wrap: wrap;
            .address-item {
              position: relative;
              margin: 10px 5px;
              width: 265px;
              height: 100px;
              padding: 10px 10px 10px 45px;
              color: #191a1c;
              border: 1px solid #e3e3e3;
              border-radius: 6px;
              cursor: pointer;
              .location {
                position: absolute;
                top: 16px;
                left: 16px;
                width: 20px;
                height: 24px;
              }
              .content1 {
                width: 200px;
                font-size: 12px;
                margin: 5px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                span {
                  margin: 0 3px;
                }
              }
              .content2 {
                width: 200px;
                font-size: 13px;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .contact {
                width: 200px;
                margin-top: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .btn-edit {
                position: absolute;
                right: 10px;
                bottom: 5px;
                font-size: 12px;
              }
              &.active {
                border: 1px solid #fa3d5a;
              }
            }
          }
        }

        &.product-panel {
          max-width: 1140px;
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            table-layout: fixed;
            border: 1px solid #e5e5e5;
            thead {
              background: #f6f7fa;
              line-height: 52px;
              color: #575859;
              font-size: 14px;
              text-align: center;
            }
            th,
            td {
              border: 1px solid #e5e5e5;
              text-align: center;
              width: 190px;
              &:first-child {
                width: auto;
                min-width: 300px;
                max-width: 480px;
              }
            }
            tbody {
              tr {
                td {
                  .info {
                    position: relative;
                    width: 480px;
                    height: 110px;
                    // border-right: 1px solid #e3e3e3;
                    .image {
                      position: absolute;
                      top: 20px;
                      left: 20px;
                      width: 68px;
                      height: 68px;
                      object-fit: cover;
                    }
                    .name {
                      position: absolute;
                      top: 34px;
                      left: 150px;
                      color: #191a1c;
                      font-size: 14px;
                      font-weight: 500;
                    }
                    .category {
                      position: absolute;
                      top: 66px;
                      left: 150px;
                    }
                  }
                }
              }
            }
          }
          .th {
            display: flex;
            flex-wrap: nowrap;
            line-height: 52px;
            text-align: center;
            background: #f6f7fa;
            border-radius: 5px 5px 0px 0px;
            border: 1px solid #e3e3e3;
            color: #575859;
            font-size: 14px;
            .info {
              width: 480px;
            }
            .size {
              width: 190px;
            }
            .quantity {
              width: 190px;
            }
            .price {
              width: 190px;
            }
          }
          .td {
            display: flex;
            flex-wrap: nowrap;
            text-align: center;
            border: 1px solid #e3e3e3;
            .info {
              position: relative;
              width: 480px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
              .image {
                position: absolute;
                top: 20px;
                left: 20px;
                width: 68px;
                height: 68px;
                object-fit: cover;
              }
              .name {
                position: absolute;
                top: 34px;
                left: 150px;
                color: #191a1c;
                font-size: 14px;
                font-weight: 500;
              }
              .category {
                position: absolute;
                top: 66px;
                left: 150px;
              }
            }
            .size {
              padding: 0 5px;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              align-content: center;
              justify-content: center;
              width: 190px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .quantity {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .price {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
              font-weight: bold;
              font-size: 14px;
            }
          }
        }

        &.summary-panel {
          max-width: 1140px;
          .wrap {
            background: #f6f7fa;
            display: flex;
            flex-wrap: nowrap;
            .left {
              width: 550px;
              border: 1px solid #e3e3e3;
              padding: 0 20px;
              .item {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0;
                height: 55px;
                font-size: 12px;
                border-bottom: 1px solid #e3e3e3;
                .label {
                  width: 100px;
                  color: #191a1c;
                  font-weight: bold;
                }
                .text {
                  color: #7e7f80;
                  input {
                    border: none;
                    outline: none;
                  }
                }
              }
            }
            .right {
              padding: 0 20px;
              .title {
                font-size: 15px;
                height: 55px;
                line-height: 55px;
                margin: 10px 0;
                font-weight: bold;
              }
              textarea {
                width: 550px;
                height: 350px;
                outline: none;
                padding: 10px;
                border: none;
                background: white;
              }
            }
          }
        }
      }
    }
    .right-box {
      //   width: 360px;
      flex: 1;
      min-width: 100px;
      max-width: 360px;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.operation-panel {
          // position: absolute;
          // top: 105px;
          // right: 180px;
          //   width: 360px;
          width: 100%;
          // height: 550px;
          .order-img {
            margin-top: 25px;
            width: 68px;
            height: 68px;
            object-fit: cover;
            object-position: center;
          }
          .item {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            margin: 10px 0;
            height: 30px;
            font-size: 12px;
            .label {
              width: 100px;
              color: #575859;
            }
            .text {
              font-weight: bold;
              color: #333333;
            }
          }
          .separator {
            height: 2px;
            background: #e3e3e3;
          }
          .integral {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .checkbox-label {
              color: #1f1f1f;
              font-size: 14px;
              line-height: 53px;
              span {
                color: #666666;
                font-size: 12px;
                line-height: 53px;
              }
            }
            .checkbox-value {
              color: #1f1f1f;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .pay-list {
            padding: 25px;
            background: #f3f6f8;
            border-radius: 10px;
            .pay-item {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              margin: 8px 0;
              color: #11192d;
              font-size: 14px;
              input {
                margin-right: 10px;
              }
              .icon {
                width: 20px;
                height: 20px;
              }
              div {
                margin-left: 10px;
              }
            }
          }

          .expedited {
            margin-top: 20px;
            font-weight: bold;
            font-size: 14px;
          }

          .btn-checkout {
            cursor: pointer;
            //   position: absolute;
            // width: 320px;
            //   bottom: 40px;
            width: 100%;
            margin-top: 50px;
            height: 42px;
            line-height: 42px;
            color: white;
            background: #fa3d5a;
            text-align: center;
            font-size: 14px;
            border-radius: 10px;
          }
        }
      }
    }
  }
}

::v-deep .popup-modal {
  display:flex;
  flex-direction:column;
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    flex:1;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      width:100%;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        flex-shrink:0;
      }
      .form-control {
        position: relative;
        flex:1;
        .input {
          width: 100%;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

::v-deep .ivu-input {
  width: 100%;
  height: 48px;
  line-height: 48px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 0 10px;
  outline: none;
}
</style>
